// Config slim do Portal do Contribuinte (fork do frontend/ Auditoria).
// Só os campos que as libs Minimal copiadas realmente consomem:
//  - appVersion  -> versão default do SettingsProvider (settings-config.ts)
//  - assetsDir   -> prefixo de assets estáticos (empty-content.tsx etc.)
// serverUrl fica '' de propósito: o front chama SEMPRE /portal-api/... (mesma
// origem; o nginx proxia). Os call-sites embutem o prefixo /portal-api no path.

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  assetsDir: string;
  maintenanceMode: boolean;
  auth: {
    method: 'jwt';
    skip: boolean;
    redirectPath: string;
  };
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'Portal do Contribuinte',
  appVersion: '0.1.0',
  serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
  // O portal roda sob base '/portal/' (Vite). Sem prefixar a base, assets de
  // template (ex.: empty-content ic-content.svg) viravam /assets/... e davam 404
  // — o correto é /portal/assets/... . BASE_URL já vem com barra final.
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? import.meta.env.BASE_URL.replace(/\/+$/, ''),
  maintenanceMode: false,
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: '/login',
  },
};
